import request from '../../shared/request'

export function getUnscheduledRequestList() {
  return request('/driver_requests/unscheduled/')
}

export function getScheduledRequestList() {
  return request('/driver_requests/scheduled/')
}

export function editDriverRequestDelivery(id, payload) {
  return request(`/driver_requests/${id}/delivery/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteDriverRequestDelivery(driverRequestId, scheduleId, payload) {
  return request(`/driver_requests/${driverRequestId}/delivery/${scheduleId}`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/driverRequest.js